import React from 'react'
import PropTypes from 'prop-types'

export function LoginLayout (props) {
  return (
    <mosaic-page>
      <mosaic-authentication>
        <mosaic-authentication-container bg-img='https://cdn.svc.oneadvanced.com/mosaic-images/bg-1280x800.jpg'>
          <mosaic-authentication-card app-name='Business Tax Portal'>
            { props.children }
            <mosaic-authentication-card-footer>
              <small>© <a href='https://www.oneadvanced.com/' target='blank'>Advanced</a>. All rights reserved. Version {props.env.VERSION}</small>
            </mosaic-authentication-card-footer>
          </mosaic-authentication-card>
        </mosaic-authentication-container>
      </mosaic-authentication>
    </mosaic-page>
  )
}

LoginLayout.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  env: PropTypes.object
}
